import { useQuery} from '@tanstack/react-query';;
import { useDeliveryBoyMapApi } from '../../hooks/useDeliveryBoyMapApi';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
  latitude?: number;
  longitude?: number;
};


export const useAllDeliveryBoyMap = (queryParams: Params) => {
  const { getAllDeliveryBoyMap } = useDeliveryBoyMapApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getDeliveryBoyMap', queryParams],
    queryFn: () => {
      return getAllDeliveryBoyMap(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch
  };
};





